import {
  Box,
  Button,
  CircularProgress,
  Flex,
  Text,
  VStack,
} from '@chakra-ui/core';
import { CheckCircleIcon, WarningIcon } from '@chakra-ui/icons';
import React from 'react';

const DashedCircle = () => (
  <Box
    width="20px"
    height="20px"
    borderRadius="100px"
    backgroundImage={`url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='100' ry='100' stroke='%23D8D8D8FF' stroke-width='4' stroke-dasharray='4' stroke-dashoffset='83' stroke-linecap='butt'/%3e%3c/svg%3e")`}
  ></Box>
);

const BetConfirmationStep = ({
  label,
  completeLabel,
  complete,
  error,
}: Confirmation) => {
  return (
    <Flex alignItems="center">
      {complete ? (
        <CheckCircleIcon boxSize="20px" color="blue.600" />
      ) : error ? (
        <WarningIcon color="red.500" boxSize="20px" />
      ) : (
        <DashedCircle />
      )}

      <Text ml={2} fontWeight="bold" color={complete ? '#262626' : '#6D7278'}>
        {complete ? completeLabel : error ? error : label}
      </Text>
    </Flex>
  );
};

export interface Confirmation {
  label: string;
  completeLabel: string;
  complete: boolean;
  error?: string;
}
interface BetConfirmationProps {
  onNext: () => void;
  confirmations: Confirmation[];
}

const BetConfirmation = ({ onNext, confirmations }: BetConfirmationProps) => {
  const isComplete = confirmations.every((c) => c.complete);
  const isFailed = confirmations.some((c) => c.error);

  return (
    <>
      <Box textAlign="center">
        {isComplete ? (
          <CheckCircleIcon boxSize="80px" color="blue.600" />
        ) : isFailed ? (
          <WarningIcon color="red.500" boxSize="80px" />
        ) : (
          <CircularProgress
            // @ts-ignore
            isIndeterminate
            thickness="3px"
            size="80px"
            color="blue.600"
          />
        )}

        <Box margin="0 auto" width="fit-content" mt={6}>
          <VStack alignItems="flex-start" spacing={4}>
            {confirmations.map((c) => (
              <BetConfirmationStep
                label={c.label}
                completeLabel={c.completeLabel}
                complete={c.complete}
                error={c.error}
              />
            ))}
          </VStack>
        </Box>
      </Box>

      <Flex mt="1.25em">
        <Button
          ml="auto"
          backgroundColor="blue.600"
          color="white"
          disabled={!isComplete}
          onClick={onNext}
        >
          Next Step
        </Button>
      </Flex>
    </>
  );
};

export default BetConfirmation;
